import React, { useEffect, useState } from "react";
import { createPopper, Instance } from "@popperjs/core";
import cn from "classnames";

import { useIsomorphicLayoutEffect } from "shared/hooks/useIsomorphicLayoutEffect";

import { PopoverContentProps } from "../types";

import classes from "../Popover.module.scss";

const PopoverContent: React.FC<PopoverContentProps> = ({
  popoverRef,
  triggerRef,
  placement = "bottom-start",
  offset,
  close,
  children,
  className,
  isEqualWidth,
  isTransition = true,
}) => {
  const [popoverWidth, setPopoverWidth] = useState<number | "auto">("auto");

  useEffect(() => {
    if (isEqualWidth && triggerRef.current) {
      setPopoverWidth(triggerRef.current.offsetWidth);
    }
  }, [isEqualWidth, triggerRef]);

  useIsomorphicLayoutEffect(() => {
    let popper: Instance;

    if (triggerRef.current && popoverRef.current) {
      popper = createPopper(triggerRef.current, popoverRef.current, {
        placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [offset?.left || 0, offset?.top || 0],
            },
          },
          {
            name: "arrow",
            options: {
              padding: 12,
            },
          },
        ],
      });
    }

    return (): void => {
      if (popper) {
        popper.destroy();
      }
    };
  }, [triggerRef, popoverRef, offset, placement]);

  return (
    <div
      className={cn(classes.root, className, {
        [classes.rootAnimation]: isTransition,
      })}
      style={{
        width: popoverWidth,
      }}
      ref={popoverRef}
    >
      {children instanceof Function ? children({ close }) : children}
    </div>
  );
};

export default PopoverContent;
